<template>
  <div class="form-group esma_form_group">
      <label v-if="showLabel" v-bind:for="fieldID"
      :style="labelStyle"
      :class="labelClass"
      >{{fieldLabel}} <span v-if="isRequired" class="is_required" aria-hidden="true">＊</span></label>
      <div :class="fieldClass" style="padding:1px 0px 1px 7px;">
        <input
        ref="local_value"
        :type="fieldType"
        class="form-control"
        v-bind:style="filedStyle"
        :disabled="isDisabled"
        :min="minVal"
        :max="maxVal"
        v-on:input="updateValue($event.target.value)"
        v-bind:id="fieldID"
        v-bind:name="fieldID"
        :readonly = "isReadOnly"
        v-bind:value="fieldValue"
        :model = "myModel"
        placeholder="">
        <div v-if="filedStyle.indexOf('block') > -1" class="row" style="margin-left: 0px;margin-right: 0px;">
          <button  v-for="b in buttons"
          :disabled="(b.type!='callback' && b.type!='dlink') || (b.type=='callback' && (isDisabled || realValueEmpty == false)  ) || (b.type=='dlink'  && (fieldValue == null || fieldValue == '')  )"
          v-bind:key="b.label"
          class="btn btn-primary esma_btn_form btn-xs"
          @click="(ev) =>{onClick(b,ev)}"
          :style="b.btn_style">{{b.label}}</button>
        </div>

        <button v-else v-for="b in buttons"
        :disabled="(b.type!='dlink' && b.type!='callback' && isDisabled)  || fieldValue == null|| fieldValue == ''"
        v-bind:key="b.label"
        class="btn btn-primary esma_btn_form btn-xs"
        @click="(ev) =>{onClick(b,ev)}"
        :style="b.btn_style">{{b.label}}</button>
        <span v-if="dbuttons.length > 0">
      <dropdown text="" type="primary btn  btn-xs btn-primary"
        :disabled=" fieldValue == null|| fieldValue == ''"
       >
        <li  v-for="b in dbuttons"   :key="b.label">
          <a
           v-on:click="(ev) =>{onClick(b,ev)}" >{{b.label}}</a>
        </li>
        <!--<li role="separator" class="divider"></li>-->
      </dropdown>
        </span>
        <div v-show="showErrorMessage" style=" background:red;color:white;margin:2px 0px;padding:2px 5px;">
          {{erroMessage}}
        </div>
      </div>
  </div>
</template>
<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import debug from 'debug'
var debug_input = debug("esma:input-box")
import { dropdown } from 'vue-strap/dist/vue-strap.js'
Vue.component("dropdown", dropdown);
export default {
  data() {
    return {
      localDisabled:false,
      showErrorMessage:false,
      erroMessage:"",
      local_value: null,
      local_style: "",
      use_on_insert_rules : false,
      timeout_control : false,
      validation_message:"",
      validate_error_is_active:false,
      last_disable_status :true,
      cache_for_disable_and_clean_if_value:false,
      label_class:"col-xs-4 control-label esma_form_label",
      local_refresh_sequecnce: 1,
      show_as_error:false,
      disabled_is_required:false,
      external_disabled:false,
      page_controller_disabled:false,
    };
  },
  computed: {
    pageControllerDisabled:{
      get(){
        return this.page_controller_disabled;
      },
      set(v){
        this.page_controller_disabled = v;
      }
    },
    externalDisabled:{
      get(){
        return this.external_disabled;
      },
      set(v){
        this.external_disabled = v;
      }
    },
    disabledIsRequired:{
      get(){
        return this.disabled_is_required;
      },
      set(v){
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        this.disabled_is_required = v;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
      }
    },
    isRequired(){
      return this.localRefreshSequecnce > 0 && this.disabledIsRequired == false && (this.$props.data.error_if_blank || false);
    },
    showAsError:{
      get(){
        return this.show_as_error;
      },
      set(v){
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce:{
      get(){
        return this.local_refresh_sequecnce;
      },
      set(v){
        this.local_refresh_sequecnce = v;
      }
    },
    minVal(){
      if(this.$props.data.min_value){
        return parseInt(this.$props.data.min_value)
      }else{
        return false;
      }
    },
    maxVal(){
      return this.$props.data.max_value || false;
    },
    labelClass(){
      var complement = (this.showAsError == true)? " esma_error_field":"";
      if(typeof this.$props.data.label_class != "undefined"){
        return this.$props.data.label_class + complement
      }else{
        return this.label_class + complement
      }
    },
    myModel:{
      get(){
        return this.my_model;
      },
      set(v){
        this.my_model = v;
      }
    },
    stateCurrentRow(){
      if(typeof this.$props.data.state_current_row != "undefined"){
        // console.log("stateCurrentRow YES", this.$props.data.label)
        return this.$props.data.state_current_row;
      }else{
        // console.log("stateCurrentRow NO")
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.$props.data.state_current_editing != "undefined"){
        console.log("stateCurrentEditing YES", this.$props.data.label)
        return this.$props.data.state_current_editing;
      }else{
        console.log("stateCurrentEditing NO")
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.$props.data.state_is_editing_new != "undefined"){
        return this.$props.data.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    realValueEmpty(){
      return true;
    },
    fieldLabel() {
      this.erroMessage = "";
      this.showErrorMessage = false;
      return this.$props.data.label;
    },

    fieldValue() {
      if (
        typeof this.$props.data.default != "undefined" &&
        (typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined" ||
          this.$store.state[this.stateCurrentRow][this.fieldID].length == 0)
      ) {
        this.updateValue(this.$props.data.default);
        return this.$props.data.default;
      } else {
        setTimeout(()=>{
          this.validate(this.$store.state[this.stateCurrentRow][this.fieldID],"fieldValue 2");
        },100)

        return (this.localRefreshSequecnce > 0) ? this.$store.state[this.stateCurrentRow][this.fieldID] : "";
      }
    },
    fieldClass() {
      if(typeof this.$props.data.field_class != "undefined"){
        return this.$props.data.field_class;
      }else if (this.getOption("hide_label", false) == true) {
        return "col-xs-12";
      } else {
        return "col-xs-8";
      }
    },
    showLabel() {
      if (this.getOption("hide_label", false) == true) {
        return false;
      } else {
        return true;
      }
    },
    fieldTableName() {
      return this.$props.data.table_name;
    },
    fieldID() {
      return this.$props.data.id;
    },
    isReadOnly(){
      return this.$props.data.force_readonly || false;
    },
    isDisabled() {
      var ret =  false;
      if (this.$store.state[this.stateIsEditingNew] == true) {
        ret = (
          this.pageControllerDisabled ||
          this.localDisabled ||
          this.externalDisabled ||
          this.$props.read ||
          typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"
        ); //TODO, can also has another field to force it.
      }else{
        ret = (
          this.pageControllerDisabled ||
          this.localDisabled ||
          this.externalDisabled ||
          this.$props.data.disabled ||
          this.$props.read ||
          typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined"
        );
      }
      if(this.last_disable_status != ret){
        this.last_disable_status = ret;
        if(ret == true){
          this.validate(this.$store.state[this.stateCurrentRow][this.fieldID],"isDisabled");
        }
      }
      // debug_input("TEST","isDisabled", this.fieldID,ret,this.$store.state[this.stateIsEditingNew])
      return ret;
    },
    buttons() {
      return this.$props.data.buttons || [];
    },
    dbuttons() {
      return this.$props.data.dbuttons || [];
    },
    filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || "";
      return (this.$props.data.field_style || "") + this.local_style + store_style;
    },
    fieldType() {
      return this.$props.data.field_type || "text"
    },
    labelStyle() {
      return (this.$props.data.label_style || "") + this.local_style;
    }
  },
  methods: {
    validate(str, requester){
      var valid = true;
      var error_message = "";
      var error_mode = "none"; //warning, restrict, convert
      if(str && str.length >0 && this.$props.data.format_rules){

        var format_rules_arr = this.$props.data.format_rules;
        format_rules_arr = (Array.isArray(format_rules_arr))?format_rules_arr:[format_rules_arr];

        format_rules_arr.forEach((format_rules)=>{
          if(valid != false){
            var code, i, len;
            var accept = format_rules.accept ||"all";
            error_mode = format_rules.mode;
            var l_str = _.clone(str);

            switch (accept) {
              case "regex":
                var regex = format_rules.regex;
                var msg = format_rules.regex_err_msg ||"error";
                valid = RegExp(format_rules.regex).test(l_str);
                if(!valid){
                  if(error_mode == "restrict"){
                    error_message = "エラー：「"+this.fieldLabel + "」 " + msg;
                  }else{
                    error_message = "注意 ：「"+this.fieldLabel + "」 " + msg;
                  }
                }
                break;
              case "all":
              default:
                break;
            }
          }

        })


        this.$notify({clean:true});
      }else  if(this.validate_error_is_active == true){
        error_mode = (Array.isArray(this.$props.data.format_rules))? this.$props.data.format_rules[0].mode : this.$props.data.format_rules.mode;
      }
      if(!valid){
        this.validate_error_is_active = true;
        this.$emit("error_msg",{msg:error_message,error_mode:error_mode})
      }else if(this.validate_error_is_active == true){
        this.validate_error_is_active = false;
        this.$emit("error_msg",{msg:"",error_mode:error_mode})
      }
      return valid;
    },
    onClick(b,ev) {

      if(ev.clientX == 0){
        return
      }
      if (b.type == "add_to_input") {
        this.$refs.local_value.value = b.text;
        this.$store.state[this.stateCurrentEditing][this.fieldID] = b.text;
      }
      if (b.type == "link") {
        this.$router.push(b.link);
      }
      if (b.type == "callback") {
        b.callback(b);
      }
      if (b.type == "dlink") {
        var url = b.link;
        if(this.fieldValue && this.fieldValue.length > 0){
          url = url.replace("{{val}}",this.fieldValue);
          this.$ajax.post(url.replace("/#/open_","/check_"), {}, (err, result, error_code) => {
            this.$notify({clear:true});
            if(result == true){
                window.open(url, "_blank");
            }else if(err){
              this.$notify({
                title: "エラー",
                text: err,
                type: "error",
                duration: 10000
              });
            }else{
              this.$notify({
                title: "エラー",
                text: " 宛先ページで"+this.fieldLabel +" = "+this.fieldValue+" が見つかりませんでした。",
                type: "warn",
                duration: 7000
              });
            }
          });
        }
      }
      return false;
    },
    updateValue(d) {
      this.validate(_.clone(d),"updateValue")
      this.$notify({clean:true})
      if(this.fieldType == "number"  && ( isNaN(d) || (this.minVal !== false && parseInt(d) < parseInt(this.minVal)))){

        d = parseInt((""+d).replace(/[^0-9-.]/g, '') || 0)
        if(isNaN(d)){
          // d = this.minVal || "";
          d =""
        }
        if(d < this.minVal){
          d = "";
        }
        setTimeout(() => {
          this.$store.state[this.stateCurrentRow][this.fieldID] = d;
          this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
            // this.updateValue(local_val);
          this.localRefreshSequecnce++;
          this.$notify({
            title: (this.minVal || 0) + '以下の数量を登録することはできません。',
            text: "",
            type: 'error',
            duration: 10000
          });
        }, 100);
      }else if(this.fieldType == "number" && this.minVal !== false && parseInt(d) >= parseInt(this.minVal)){
        d = parseInt(d);
        this.$store.state[this.stateCurrentRow][this.fieldID] = d;
        this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
        this.localRefreshSequecnce++;
      }else{
        this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
      }
      if(this.$props.data.emit_input == true){
        this.$emit("on_update",{field:this.fieldID,val:d});
      }
      if (typeof this.$props.data.on_set_value == "function") {
        this.$props.data.on_set_value(d)
      }
      if(this.use_on_insert_rules){
        // Emit event
        clearTimeout(this.timeout_control);
        this.timeout_control = setTimeout( () => {
          bus.$emit("on_insert_rule",{
            rule:this.$props.data.on_insert_rules,
            value:d
          });
          // console.log("on_insert_rule EVENT EMITED" )
        }, 500);
      }
    },
    getOption(name, def) {
      if (typeof this.$props.option[name] == "undefined") {
        return def;
      }
      return this.$props.option[name];
    }
  },

  props: ["data", "value", "option", "read"],
  mounted(){
    this.$props.data.ref_field = this;
    if(typeof this.$props.data.listen_for != "undefined" && this.$props.data.listen_for.length > 0){
      this.listen_for = this.$props.data.listen_for;
      this.listen_for.forEach((e)=>{
        bus.$off(e.name).$on(e.name,(data)=>{
          if(e.mode == "disable_if_value"){
            if(e.disable_if_value == data.val){
              this.localDisabled = false;
            }else{
              this.localDisabled = true;
            }
          }else if(e.mode == "disable_and_clean_if_value"){

            if(e.disable_if_value == data.val){
              if(this.localDisabled != false && this.cache_for_disable_and_clean_if_value != false){
                this.$store.state[this.stateCurrentRow][this.fieldID] = this.cache_for_disable_and_clean_if_value||"";
                this.$store.state[this.stateCurrentEditing][this.fieldID] = this.cache_for_disable_and_clean_if_value||"";
                this.cache_for_disable_and_clean_if_value = "";
              }
              this.localDisabled = false;
            }else{
              if(this.localDisabled != true){
                this.cache_for_disable_and_clean_if_value = "" + (this.$store.state[this.stateCurrentEditing][this.fieldID] || this.$store.state[this.stateCurrentRow][this.fieldID]||this.$props.data.default||"");
              }
              this.localDisabled = true;
              this.$store.state[this.stateCurrentRow][this.fieldID] = this.$props.data.default||"";
              this.$store.state[this.stateCurrentEditing][this.fieldID] = this.$props.data.default||"";
            }
          }
        })
      })
    }

    if(typeof this.$props.data.listen_for_value != "undefined"){
      var bus_name = this.$props.data.listen_for_value;
      bus.$off(bus_name).$on(bus_name,(new_value)=>{
        debug_input("listen_for_value", this.fieldID, new_value, this.$store.state[this.stateCurrentEditing][this.fieldID])
        this.$refs.local_value.value = new_value;
        this.updateValue(new_value);
      })
    }

    if(typeof this.$props.data.on_insert_rules != "undefined"){
      this.use_on_insert_rules = true;
    }

    this.$props.data.on_field_messages = (vm,msg,cb) =>{
      if(msg && msg.msg_type == "error"){
        if(msg.show_as_error_mode == false && this.showAsError == false){
          return cb(false);
        }
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        if(msg.show_as_error_mode && msg.only_if_enabled == true && this.isDisabled == true){
          this.showAsError = false;
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValue(local_val);
          this.localRefreshSequecnce++;
          return cb(false);
        }
        this.showAsError = msg.show_as_error_mode || false;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;
        return cb(true);
      }
    }

    if(this.$props.data.page_controller){
      this.$props.data.page_controller_msg = (options) =>{
        switch (options.cmd) {
          case "enable":
            this.pageControllerDisabled = false;
            break;
          case "disable":
            this.pageControllerDisabled = true;
            break;
          default:
            break;
        }
      }
    }
  },
};
</script>
<style scoped>
.esma_error_field {
  color:red;
}
.is_required{
  color:red;
}
.form-control {
  color: black;
  height: 24px;
  padding: 0px 6px 0px 6px;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  background-color: #ccc;
}
.form-control::selection {
  color: white;
  background: #575757;
}
.form-control {
  height: 24px;
  color: black;
}

</style>



// WEBPACK FOOTER //
// input-box.vue?6e99d67a